// PrepFormThread.jsx
import React from 'react';
import PrepForm from '../Prep/PrepForm';

const PrepFormThread = ({ thread }) => {
  // Parse initial values from the saved thread
  const { metadata = {}, data = {}, name = '', id = '' } = thread;

  const initialFormData = {
    meetingGoal: metadata.meetingGoal || '',
    customGoal: metadata.customGoal || '',
    industry: metadata.industry || '',
    companyName: metadata.companyName || '',
    companyWebsite: metadata.companyWebsite || '',
    geography: metadata.geography || '',
    contactName: metadata.contactName || '',
    contactRole: metadata.contactRole || '',
    companySize: metadata.companySize || '',
    relationshipStatus: metadata.relationshipStatus || '',
  };

  return (
    <PrepForm
      key={id} // ✅ Forces a fresh mount
      existingFormData={initialFormData}
      existingChatHistory={data.chat || []}
      existingPrepName={name}
      existingThreadId={id}
      prepResultFull={data.prepResultFull || ''}
      isReadOnly={true}
      isThread={true}
      scrollToOutputOnMount={false}
    />
  );
};

export default PrepFormThread;
